import { useState } from 'react';
import { ISortProperty } from '../../../../../../BaseComponents/Table/Components/SortableTableUtils';
import { TVisningstyp } from '../../../../../../Features/Delsystem/_Common/Components/BusinessCollectionComponents/BusinessDataSet/BusinessDataSet';
import FunctionItem from '../../../../../../Features/Delsystem/_Common/Components/FunctionMenu/FunctionItem/FunctionItem';
import FunctionMenu from '../../../../../../Features/Delsystem/_Common/Components/FunctionMenu/FunctionMenu';
import {
  defaultRoutineLayoutId,
  defaultRoutineLayoutName,
} from '../../../../../../Features/Routing/ActiveRoutine/ActiveRoutineContext';
import { IColumnDef } from '../../../../../../Types/ColumnDefType';
import { isDevelopment } from '../../../../../../Utils/isDevelopment';
import SaveKolumnSettingDialog from '../SaveKolumnSettingDialog/SaveKolumnSettingDialog';

interface IProps {
  selectedKolumnSetting: string | null;
  setSelectedKolumnSetting: (id: string | null) => void;
  favouriteKolumnSetting: string | null | undefined;
  setFavouriteKolumnSetting: (id: string | null) => void;
  valdaKolumner: readonly IColumnDef[];
  showDetailsRight: boolean;
  sortOrder: ISortProperty[];
  visningstyp: TVisningstyp;
  showDevOptions: boolean;
  setShowDevOptions: (showDevOptions: boolean) => void;
  collectionName: string;
}

const KolumnValjareFunctionMenu: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const isFavourite =
    props.favouriteKolumnSetting &&
    props.favouriteKolumnSetting === props.selectedKolumnSetting;

  const [editSettingDialogOpen, setEditSettingDialogOpen] = useState(false);
  const [saveNewSettingDialogOpen, setSaveNewSettingDialogOpen] =
    useState(false);

  return (
    <>
      <FunctionMenu id="KolumnValjareFunctionMenu" highEmphasis>
        <FunctionItem
          iconType="save_alt"
          onClick={() => {
            setEditSettingDialogOpen(true);
          }}
          disabled={
            Boolean(!props.selectedKolumnSetting) ||
            props.selectedKolumnSetting === defaultRoutineLayoutId
          }
          disabledReason={
            !props.selectedKolumnSetting
              ? 'Ingen inställning vald'
              : props.selectedKolumnSetting === defaultRoutineLayoutId
              ? `Kan inte spara ${defaultRoutineLayoutName}`
              : undefined
          }
        >
          Spara
        </FunctionItem>
        <FunctionItem
          iconType="save_as"
          onClick={() => {
            setSaveNewSettingDialogOpen(true);
          }}
        >
          Spara som
        </FunctionItem>
        <FunctionItem
          iconType={isFavourite ? 'star' : 'star_border'}
          onClick={() => {
            props.setFavouriteKolumnSetting(
              isFavourite ? null : props.selectedKolumnSetting
            );
          }}
          disabled={
            Boolean(!props.selectedKolumnSetting) ||
            props.selectedKolumnSetting === defaultRoutineLayoutId
          }
          disabledReason={
            !props.selectedKolumnSetting
              ? 'Ingen inställning vald'
              : props.selectedKolumnSetting === defaultRoutineLayoutId
              ? `Kan inte välja ${defaultRoutineLayoutName} som favorit`
              : undefined
          }
        >
          {isFavourite ? 'Välj bort favorit' : 'Välj som favorit'}
        </FunctionItem>

        {isDevelopment && (
          <FunctionItem
            onClick={() => props.setShowDevOptions(!props.showDevOptions)}
          >
            {`${
              props.showDevOptions ? 'Dölj' : 'Visa'
            } alla alternativ (endast i dev)`}
          </FunctionItem>
        )}
      </FunctionMenu>
      <SaveKolumnSettingDialog
        title="Spara"
        open={editSettingDialogOpen}
        onClose={() => {
          setEditSettingDialogOpen(false);
        }}
        selectedKolumnSetting={props.selectedKolumnSetting}
        setSelectedKolumnSetting={props.setSelectedKolumnSetting}
        valdaKolumner={props.valdaKolumner}
        showDetailsRight={props.showDetailsRight}
        sortOrder={props.sortOrder}
        visningstyp={props.visningstyp}
        collectionName={props.collectionName}
      />
      <SaveKolumnSettingDialog
        title="Spara som"
        open={saveNewSettingDialogOpen}
        onClose={() => {
          setSaveNewSettingDialogOpen(false);
        }}
        setSelectedKolumnSetting={props.setSelectedKolumnSetting}
        valdaKolumner={props.valdaKolumner}
        showDetailsRight={props.showDetailsRight}
        sortOrder={props.sortOrder}
        visningstyp={props.visningstyp}
        collectionName={props.collectionName}
      />
    </>
  );
};

export default KolumnValjareFunctionMenu;
